export default __webpack_public_path__ + "static/media/moderator-devices-icon-active.842b8bba.svg";